<!--div cdkDropListGroup>
  <app-multi-drag-drop
    [items]="itemsList"
    (itemsRemoved)="itemsRemoved($event, 1)"
    (itemsAdded)="itemsAdded($event, 1)"
    (itemsUpdated)="itemsUpdated($event, 1)"
    (selectionChanged)="selectionChanged($event, 1)"
  >
    <ng-template let-item>
      
      <div class="media">
        <img src="{{item.icon?item.icon.url:item.multimedia[0].url}}" class="rounded-circle me-2"
          alt="img-placeholder" height="50" width="50">
        <div class="media-body">
          <h6 class="">{{item.title?item.title:item.default_label}}</h6>
          <div class="d-flex justify-content-between pe-1">
            <span class="badge"
              [ngClass]="{'bg-light-success':item.status == 'PUBLISHED', 'bg-light-warning':item.status == 'UNPUBLISHED'}">
              {{ item.status }}
            </span>
            <span *ngIf="item.price" class=""
            >
            {{ item.price.sale_price.amount | currency:item.price.sale_price.currency:symbol:'':'' }}
            </span>
            
          </div>
        </div>
      </div>
    </ng-template>
  </app-multi-drag-drop>
  <br/>
  <app-multi-drag-drop
    [items]="selectedItems"
    (itemsRemoved)="itemsRemoved($event, 2)"
    (itemsAdded)="itemsAdded($event, 2)"
    (itemsUpdated)="itemsUpdated($event, 2)"
    (selectionChanged)="selectionChanged($event, 1)"
  >
    <ng-template let-item>
      <div class="media">
        <img src="{{item.icon?item.icon.url:item.multimedia[0].url}}" class="rounded-circle me-2"
          alt="img-placeholder" height="50" width="50">
        <div class="media-body">
          <h6 class="">{{item.title?item.title:item.default_label}}</h6>
          <div class="d-flex justify-content-between pe-1">
            <span class="badge"
              [ngClass]="{'bg-light-success':item.status == 'PUBLISHED', 'bg-light-warning':item.status == 'UNPUBLISHED'}">
              {{ item.status }}
            </span>
            <span *ngIf="item.price" class=""
            >
            {{ item.price.sale_price.amount | currency:item.price.sale_price.currency:symbol:'':'' }}
            </span>
            
          </div>
        </div>
      </div>
    </ng-template>
  </app-multi-drag-drop>
</!--div-->
<div *ngIf="selectedItems" cdkDropListGroup class="d-flex flex-row round" #container>
  <div class="flex-fill my-1 p-2">
    <div class="form-group row">
      <label class="col-md-4 font-small-3 mt-1">{{'menu_available' | translate}}</label>
      <div class="col-md-8 pe-0 me-0">
        <fieldset class="form-group position-relative has-icon-right">
          <input type="text" (keyup)="searchAvailableEvent($event.target.value)" class="form-control form-control-sm"
            id="" [placeholder]="'menu_search_placeholder' | translate">
          <div class="form-control-position">
            <i class="bi bi-search"></i>
          </div>
        </fieldset>
      </div>
    </div>

    <div>
      <app-multi-drag-drop [items]="itemsList" [multiple]="multipleItems" [dragZone]="'available'" [isPDP]="isPDP"
        (itemsRemoved)="itemsRemoved($event, 1)" (itemsAdded)="itemsAdded($event, 1)"
        (itemsUpdated)="itemsUpdated($event, 1)" (selectionChanged)="AvailableSelectionChanged($event, 1)">
        <ng-template let-item>
          <div class="d-flex align-items-center w-100">
            <div class="product-thumb-wrapper me-2 flex-shrink-0">
              <ng-container
                *ngIf="!item._imageError && (item.icon?.url || item.multimedia?.[0]?.url); else availablePlaceholder">
                <img [src]="item.icon?.url || item.multimedia[0].url" class="rounded-circle" alt="img-placeholder"
                  width="40" height="40" (error)="onImageError(item)">
              </ng-container>
              <ng-template #availablePlaceholder>
                <div
                  class="product-thumb-placeholder rounded-circle d-flex align-items-center justify-content-center bg-light"
                  style="width: 40px; height: 40px;">
                  <i class="bi bi-image-alt text-muted"></i>
                </div>
              </ng-template>
            </div>
            <div class="flex-grow-1 overflow-hidden">
              <h6 class="mb-0 text-truncate">{{item.title?item.title:item.default_label}}</h6>
              <div class="d-flex align-items-center gap-1">
                <span class="badge font-small-1"
                  [ngClass]="{'bg-light-success':item.status == 'PUBLISHED', 'bg-light-warning':item.status == 'UNPUBLISHED'}">
                  {{ item.status }}
                </span>
                <span *ngIf="item.price" class="text-muted font-small-1 text-truncate">
                  {{'menu_unit_in_stock' | translate}}: {{ item.stock}}
                </span>
              </div>
            </div>
          </div>
        </ng-template>
      </app-multi-drag-drop>
    </div>
  </div>
  <div class="vmid arrows-desktop flex-shrink-0">
    <a (click)="moveItemTo()">
      <img src="/assets/img/svg/Arrows.svg" />
    </a>

  </div>

  <div class="flex-fill mt-1 p-2">

    <div class="form-group row">
      <label class="col-md-4 font-small-3 mt-1">{{'menu_selected' | translate}}</label>
      <div class="col-md-8 pe-0 me-0">
        <fieldset class="form-group position-relative has-icon-right">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="searchSelectedText" id="iconLeft2"
            [placeholder]="'menu_search_placeholder' | translate">
          <div class="form-control-position">
            <i class="bi bi-search"></i>
          </div>
        </fieldset>
      </div>
    </div>
    <div>
      <app-multi-drag-drop [items]="selectedItems" [dragZone]="'selected'" [isPDP]="isPDP" [multiple]="multipleItems"
        [searchText]="searchSelectedText" [searchKey]="searchKey" (itemsRemoved)="itemsRemoved($event, 2)"
        (itemsAdded)="itemsAdded($event, 2)" (itemsUpdated)="itemsUpdated($event, 2)"
        (selectionChanged)="SelectedSelectionChanged($event, 2)">
        <ng-template let-item>
          <div class="d-flex align-items-center w-100">
            <div class="product-thumb-wrapper me-2 flex-shrink-0">
              <ng-container
                *ngIf="!item._imageError && (item.icon?.url || item.multimedia?.[0]?.url); else selectedPlaceholder">
                <img [src]="item.icon?.url || item.multimedia[0].url" class="rounded-circle" alt="img-placeholder"
                  width="40" height="40" (error)="onImageError(item)">
              </ng-container>
              <ng-template #selectedPlaceholder>
                <div
                  class="product-thumb-placeholder rounded-circle d-flex align-items-center justify-content-center bg-light"
                  style="width: 40px; height: 40px;">
                  <i class="bi bi-image-alt text-muted"></i>
                </div>
              </ng-template>
            </div>
            <div class="flex-grow-1 overflow-hidden">
              <h6 class="mb-0 text-truncate">{{item.title?item.title:item.default_label}}</h6>
              <div class="d-flex align-items-center gap-1">
                <span class="badge font-small-1"
                  [ngClass]="{'bg-light-success':item.status == 'PUBLISHED', 'bg-light-warning':item.status == 'UNPUBLISHED'}">
                  {{ item.status }}
                </span>
                <span *ngIf="item.price" class="text-muted font-small-1 text-truncate">
                  {{'menu_unit_in_stock' | translate}}: {{ item.stock}}
                </span>
              </div>
            </div>
            <a type="button" class="btn btn-sm p-1 ms-1 flex-shrink-0"
              (click)="removeItem(item); $event.stopPropagation()" (mousedown)="$event.stopPropagation()"
              (touchstart)="$event.stopPropagation()">
              <i class="bi bi-x grey font-medium-3"></i>
            </a>
          </div>
        </ng-template>
        <ng-template #empty>
          <div
            class="w-100 h-100 d-flex flex-column align-items-center justify-content-center position-absolute top-0 start-0">
            <p class="grey mb-1">{{'menu_drop_items_here' | translate}}</p>
            <i class="bi bi-file-earmark-arrow-up grey" style="font-size: 4rem"></i>
          </div>
        </ng-template>
      </app-multi-drag-drop>
    </div>
  </div>

</div>